import * as CustomControls from '../components/formControls/custom/index';
import { isValidControlType } from '../engineClient/reducers/isValidControlType';

/*
 * This needs to be in its own file because it references controls that we don't want to be used in any server-side features.
 */
export function isValidClaimsControlType(controlType: string): boolean {
  return isValidControlType(controlType) || CustomControls[controlType];
}
